// Add your custom JS here.

jQuery(function ($) {
    $(document).ready(function () {

        //Swiper
        var swiper = new Swiper(".mySwiper", {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
          });
          var swiper2 = new Swiper(".mySwiper2", {
            loop: true,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            thumbs: {
              swiper: swiper,
            },
          });
    
        //Jarallax
        $('.jarallax').jarallax({
            speed: 0.2,
          });


          $('#playButton, .inizia-corso').on('click', function () {
            // Nascondi il div "inizia-corso" con un ritardo di 500ms
            $('.inizia-corso').fadeOut(500);
    
            // Riproduci il video
            var video = document.getElementById('corsoVideo');
            video.play();
        });
    });
});
